export enum InventoryType {
  Ticket = 'TICKET',
  Package = 'PACKAGE',
}

export const inventorySort = {
  priceAscending: 'PRICE_LOW_TO_HIGH',
  priceDescending: 'PRICE_HIGH_TO_LOW',
  alphabetical: 'ALPHABETICAL',
} as const

export type InventorySortKey = keyof typeof inventorySort
export type InventorySort = (typeof inventorySort)[keyof typeof inventorySort]

export type InventoryItem = {
  // basic info
  id: string
  name: string
  description: string
  type: 'TICKET' | 'PACKAGE' // TODO: check all enum options
  image: string
  location: string
  city: string
  timezone: string
  venue: string
  venueLayoutSection: null | string
  termsAndConditions?: string | null

  // state management flags
  active: boolean
  enable: boolean
  isInternal: boolean
  confirmationRequest?: string | null
  deleted: boolean

  // timestamps - canonical arrival window comes from start/end.
  start: number
  end: number
  dateStart: number
  dateEnd: number
  date: number
  modified: number
  created: number
  // Deprecated compatibility aliases derived from start/end.
  arrivalStartTime: number
  arrivalEndTime: number
  sellingStart: number
  sellingEnd: number
  checkInStart: number
  checkInEnd: number
  sellingStartDisplay: number
  sellingEndDisplay: number
  recurring: InventoryRecurrence

  // inventory
  hasTiers: number
  membershipLevel: number
  fee: InventoryFeeSettings // TODO: check to see which of these are dupes and which are utilized today
  fees: InventoryFee[]
  tier: {
    levels: InventoryTierLevel[]
    activeLevel?: InventoryTierLevel['id']
  }

  // inventory item stock, quantity, settings
  guests: number
  quantity: number
  quantityMin: number
  quantityMax: null | number
  quantityLeft: number
  quantitySold: number
  quantityTotal: number
  quantityThreshold: number
  syncQuantityBySection: boolean
  bulkUploadCode: 'H' | 'G' | 'D' | 'A' | 'C' // TODO: check db for significant values
  qrCodeUrl: string

  purchaseMin: number
  purchaseMax: null | number

  // Payment info
  tax: number
  tip: number
  price: number
  basePrice: number
  minimumPrice: number
  userPaysProcessing: boolean
  reservationEnabled: boolean
  depositAmount: number
  discountAmount: number
  discountValue: number
  discountType: 'PERCENT' | 'FLAT'
  paymentType: 'NONE' | 'ADVANCE' | 'ADVANCE_DEPOSIT' | 'VENUE'
  subType: null | string
}

// TODO: look into this on DB
export type InventoryFee = {
  amount: number
  feeType: 'OPTIONAL' | 'REQUIRED' | 'PROCESSING'
  name: string
  taxable: boolean
  type: 'FLAT' | 'PERCENT'
  value: number
}

export type InventoryFeeSettings = {
  enable: boolean
  fees: InventoryFee[] | null
}

export type InventoryTierLevel = {
  id: string
  modified: number
  created: number
  deleted: boolean
  active: boolean
  price: number
  fees: InventoryFee[]
  quantity: number
}

export type InventoryRecurrence = {
  config: {
    type: 'weekly' | 'monthly' | 'daily'
    days: number[]
    block: number
    endDate?: number | string | null
  }
  enable: boolean
  identifier: string
}
